const LOADING_MESSAGES = [
  'Consulting the mountain gods...',
  'Weighing every gram twice...',
  'Checking for midges...',
  'Arguing with a Munro bagger...',
  'Calculating faff factor...',
  'Inspecting seam tape...',
  'Debating tent vs tarp...',
  'Optimising for pub stops...',
  'Channeling Ray Mears...',
  'Ignoring your Strava fitness...',
];

export function LoadingState() {
  return (
    <div className="w-full max-w-md mx-auto text-center py-16 animate-fadeIn">
      {/* Animated loader */}
      <div className="relative w-20 h-20 mx-auto mb-8">
        {/* Outer ring */}
        <div className="absolute inset-0 border-4 border-neutral-800 rounded-full" />
        {/* Spinning arc */}
        <div className="absolute inset-0 border-4 border-transparent border-t-orange-500 rounded-full animate-spin" />
        {/* Center icon */}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" 
            />
          </svg>
        </div>
      </div>

      {/* Animated text */}
      <div className="h-8 overflow-hidden">
        <div className="animate-slideUp">
          {LOADING_MESSAGES.map((msg, idx) => (
            <p 
              key={idx} 
              className="h-8 flex items-center justify-center text-neutral-400"
            >
              {msg}
            </p>
          ))}
        </div>
      </div>

      {/* Progress dots */}
      <div className="flex justify-center gap-1.5 mt-6">
        {[0, 1, 2].map((idx) => (
          <div
            key={idx}
            className="w-2 h-2 rounded-full bg-orange-500 animate-pulse"
            style={{ animationDelay: `${idx * 200}ms` }}
          />
        ))}
      </div>
    </div>
  );
}
